/* Generated by design/v2/tokens/build.mjs — do not edit.
 * Source: design/v2/tokens/tokens.json
 *
 * Phase 4 consumes this under a v2 namespace. Values are unitless numbers so
 * React Native takes them directly.
 */
export const v2 = {
    "color": {
        "light": {
            "surface": {
                "base": "#ffffff",
                "sunken": "#e2e5ea",
                "raised": "#ffffff",
                "overlay": "#ffffff",
                "pressed": "#eff1f4"
            },
            "edge": {
                "hairline": "#d6dae0",
                "strong": "#bec4cd"
            },
            "text": {
                "primary": "#16181c",
                "secondary": "#515863",
                "faint": "#5c646e",
                "disabled": "#9aa1ac",
                "onMascot": "#000000"
            },
            "act": {
                "fill": "#16181c",
                "ink": "#ffffff",
                "pressed": "#2e333b",
                "quiet": "#ffffff"
            },
            "correct": {
                "line": "#0f7a55",
                "surface": "#dcf3ea",
                "edge": "#a9dfc9",
                "ink": "#0b6444",
                "deep": "#063523"
            },
            "wrong": {
                "line": "#bf1f3a",
                "surface": "#fbe4e8",
                "edge": "#f0bfc8"
            },
            "streak": {
                "line": "#b23a09"
            },
            "subject": {
                "growth": {
                    "hue": "#6d28d9",
                    "mid": "#8b5cf6",
                    "surface": "#eee5fd",
                    "edge": "#aa83e1",
                    "deep": "#33116b",
                    "sink": "#aa83e1"
                },
                "finance": {
                    "hue": "#03649a",
                    "mid": "#38bdf8",
                    "surface": "#deeff8",
                    "edge": "#67accc",
                    "deep": "#012b42",
                    "sink": "#67accc"
                },
                "people": {
                    "hue": "#9d1baa",
                    "mid": "#e879f9",
                    "surface": "#f7e3f9",
                    "edge": "#d078d3",
                    "deep": "#4a0c52",
                    "sink": "#d078d3"
                }
            },
            "mascot": {
                "bodyLight": "#e774f5",
                "bodyDeep": "#6a2afc",
                "goldLight": "#ffe07a",
                "goldDeep": "#f59e0b",
                "coolLight": "#8fa8d8",
                "coolDeep": "#4658a8",
                "hotLight": "#ff9a5c",
                "hotDeep": "#e0245e",
                "visor": "#ffffff",
                "eye": "#000000",
                "spark": "#ffffff",
                "tear": "#8fd3ff"
            },
            "stage": {
                "room": "#ece6fa",
                "beam": "#ffffff"
            },
            "reward": {
                "ink": "#6b4e12",
                "wash": "#fbf0d5",
                "fill": "#7a5a15",
                "onFill": "#ffffff",
                "lip": "#503a0c"
            }
        },
        "dark": {
            "surface": {
                "base": "#131417",
                "sunken": "#0d0e11",
                "raised": "#1b1d21",
                "overlay": "#23262b",
                "pressed": "#23262b"
            },
            "edge": {
                "hairline": "#2c2f35",
                "strong": "#3b3f47"
            },
            "text": {
                "primary": "#f2f3f5",
                "secondary": "#a5acb6",
                "faint": "#868d98",
                "disabled": "#565b65",
                "onMascot": "#000000"
            },
            "act": {
                "fill": "#f2f3f5",
                "ink": "#131417",
                "pressed": "#e7e9ec",
                "quiet": "#1b1d21"
            },
            "correct": {
                "line": "#34d399",
                "surface": "#0f2b22",
                "edge": "#1d5f49",
                "ink": "#4fe0ab",
                "deep": "#166b4c"
            },
            "wrong": {
                "line": "#fb7185",
                "surface": "#2e1219",
                "edge": "#6d2331"
            },
            "streak": {
                "line": "#ff8a3d"
            },
            "subject": {
                "growth": {
                    "hue": "#b49dfb",
                    "mid": "#8b5cf6",
                    "surface": "#241d38",
                    "edge": "#5c4499",
                    "deep": "#4a3f6b",
                    "sink": "#171024"
                },
                "finance": {
                    "hue": "#7dd3fc",
                    "mid": "#38bdf8",
                    "surface": "#182838",
                    "edge": "#31749b",
                    "deep": "#2f5468",
                    "sink": "#0e1a24"
                },
                "people": {
                    "hue": "#f0abfc",
                    "mid": "#e879f9",
                    "surface": "#301f38",
                    "edge": "#8e529b",
                    "deep": "#63466b",
                    "sink": "#1d1024"
                }
            },
            "mascot": {
                "bodyLight": "#e774f5",
                "bodyDeep": "#6a2afc",
                "goldLight": "#ffe07a",
                "goldDeep": "#f59e0b",
                "coolLight": "#8fa8d8",
                "coolDeep": "#4658a8",
                "hotLight": "#ff9a5c",
                "hotDeep": "#e0245e",
                "visor": "#ffffff",
                "eye": "#000000",
                "spark": "#ffffff",
                "tear": "#8fd3ff"
            },
            "stage": {
                "room": "#1a1030",
                "beam": "#ffffff"
            },
            "reward": {
                "ink": "#f0cb84",
                "wash": "#382c11",
                "fill": "#e8c170",
                "onFill": "#1a1408",
                "lip": "#a97f2e"
            }
        }
    },
    "type": {
        "family": {
            "ui": "Archivo",
            "idea": "Literata"
        },
        "scale": {
            "micro": {
                "size": 12,
                "line": 16
            },
            "small": {
                "size": 14,
                "line": 20
            },
            "body": {
                "size": 16,
                "line": 24
            },
            "lead": {
                "size": 18,
                "line": 28
            },
            "title": {
                "size": 22,
                "line": 30
            },
            "idea": {
                "size": 26,
                "line": 34
            },
            "display": {
                "size": 32,
                "line": 38
            }
        },
        "catalogue": {
            "idea": {
                "size": 25,
                "line": 32,
                "weight": 600,
                "family": "idea"
            },
            "ideaSmall": {
                "size": 18,
                "line": 25,
                "weight": 600,
                "family": "idea"
            },
            "h1": {
                "size": 26,
                "line": 32,
                "weight": 800,
                "family": "ui"
            },
            "h2": {
                "size": 19,
                "line": 25,
                "weight": 700,
                "family": "ui"
            },
            "lede": {
                "size": 16,
                "line": 24,
                "weight": 400,
                "family": "ui"
            },
            "body": {
                "size": 16,
                "line": 24,
                "weight": 500,
                "family": "ui"
            },
            "small": {
                "size": 13.5,
                "line": 19,
                "weight": 500,
                "family": "ui"
            },
            "micro": {
                "size": 11.5,
                "line": 16,
                "weight": 600,
                "family": "ui"
            },
            "display": {
                "size": 44,
                "line": 48,
                "weight": 800,
                "family": "ui"
            }
        },
        "weight": {
            "regular": 400,
            "medium": 500,
            "semibold": 600,
            "bold": 700
        }
    },
    "space": {
        "none": 0,
        "hair": 1,
        "xs": 4,
        "sm": 8,
        "md": 12,
        "lg": 16,
        "gutter": 20,
        "xl": 24,
        "section": 32,
        "idea": 48,
        "void": 64
    },
    "radius": {
        "flat": 0,
        "inline": 6,
        "panel": 14,
        "tap": 22,
        "pill": 999
    },
    "border": {
        "hairline": 1,
        "edge": 2,
        "lip": 4
    },
    "size": {
        "glyph": 14,
        "icon": 22,
        "point": 17,
        "lead": 26,
        "mark": 40,
        "label": 62,
        "track": 14,
        "control": 54
    },
    "motion": {
        "duration": {
            "instant": 0,
            "press": 90,
            "dismiss": 140,
            "reveal": 180,
            "tick": 220,
            "correct": 260,
            "wrong": 320,
            "count": 700,
            "reward": 1800,
            "stagger": 45
        },
        "easing": {
            "standard": [
                0.4,
                0,
                0.2,
                1
            ],
            "reveal": [
                0,
                0,
                0.2,
                1
            ],
            "dismiss": [
                0.4,
                0,
                1,
                1
            ],
            "overshoot": [
                0.34,
                1.56,
                0.64,
                1
            ]
        },
        "spring": {
            "press": {
                "damping": 26,
                "stiffness": 340,
                "mass": 1
            },
            "settle": {
                "damping": 30,
                "stiffness": 180,
                "mass": 1
            },
            "reward": {
                "damping": 12,
                "stiffness": 220,
                "mass": 1
            }
        },
        "stage": {
            "recede": 0,
            "beam": 120,
            "rise": 240,
            "xp": 700,
            "summary": 1100,
            "settled": 1800
        },
        "shake": {
            "amplitude": 6,
            "cycles": 3
        }
    },
    "device": {
        "width": 393,
        "height": 852,
        "insets": {
            "top": 59,
            "bottom": 34
        },
        "small": {
            "width": 360,
            "height": 640
        }
    }
};
//# sourceMappingURL=tokens.js.map